import React, {useState, useEffect} from 'react';
import axios from 'axios';
import axiosUrl from '../../axios/url';
import PropTypes from 'prop-types';


export default function TagListHeader(param) {
    // project 목록 조회
    async function getProjectList(){
        await axios.get(axiosUrl.project_list)
        .then( response => {
            // old value, new value를 비교하여 변화가 있을 때만, rendering함. 이 로직을 빼면 무한 렌더링에 빠짐.
            if(JSON.stringify(projectList) !== JSON.stringify(response.data)) { 
                console.log('Project list success');
                setProjectList(response.data) ;
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Project.getScheduleList - ' + e);
                console.error('[MEDIEX_CMS_2019_ERROR] axiosUrl - ' + axiosUrl.project_list);
        });

    }

    const [projectList, setProjectList] = useState([]);
    const [projectId, setProjectId] = useState("-1");
    const [filterList, setfilterList] = useState([]);
    const [filter, setfilter] = useState("");
    const [defaultChecked, setDefaultChecked] = useState(false);

    useEffect(() => {
        getProjectList();
    }, [projectList]); 

    function tagSearch(e) {
        setDefaultChecked(false);
        let lowercasedFilter = e.target.value.toLowerCase();
        setfilter(e.target.value);
        setfilterList(param.tagList.filter(representives => {
            let check = false;
            representives.tags.filter(lowtag => {
                if(lowtag.name.toLowerCase().includes(lowercasedFilter)) {
                    check = true;
                }
            }) 
            if(check) {
                return Object.keys(representives);
            } else {
                return Object.keys(representives).some(key =>
                    representives.name.toLowerCase().includes(lowercasedFilter)
                )
            }
          }));
    }

    useEffect(() => {
        //검색 결과 값을 넘겨주기 위해
        param.callbackFilterList(filterList);
    }, [filterList])
    

    useEffect(() => {
        setProjectId(param.projectId);
    }, [param.projectId])

    //프로젝트 id 변경
    function changeProject(e) {
        param.callbackProjectId(e.target.value);
        setProjectId(e.target.value);
    }


    return(
            <div className="col-sm-12">
                <div  className="input-group input-group-sm mr-4 flex-row-reverse">
                    
                    <label className="mr-3 font-weight-normal">Search:
                        <input type="text"  className="form-control tag-filter heifht-31" value={filter} onChange={tagSearch}/>
                    </label>
                    <div>
                        <label className="mr-2 font-weight-normal line-height-31"> 프로젝트명 : </label>
                        <select className="form-control font-weight-normal mr-4 project-select" onChange={changeProject} value={projectId}>
                            <option value={-1} >프로젝트를 선택해주세요</option>
                            {projectList.map((project, i) => (
                                <option value={project.id} key={i} >{project.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
    );
}

TagListHeader.propTypes = {
    tagList: PropTypes.any,
    callbackProjectId: PropTypes.any,
    callbackFilterList: PropTypes.any,
  };